import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

import PrimaryCta from 'components/Buttons/PrimaryCta';
const flexProps = {
  width: '33%',
  flexBasis: '33%'
};
class ViewCart extends React.Component {
  static propTypes = {
    quantity: PropTypes.number,
    subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    to: PropTypes.string,
    hasInvestorDayFeature: PropTypes.bool
  };

  render() {
    const { onClick, to, hasInvestorDayFeature } = this.props;
    return (
      <PrimaryCta
        handleClick={onClick}
        component={Link}
        to={to}
        fullWidth
        label={
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box {...flexProps}>{this.props.quantity}</Box>
            <Box
              display="flex"
              justifyContent="center"
              {...flexProps}
              whiteSpace="nowrap"
            >
              View Cart
            </Box>

            <Box {...flexProps} display="flex" justifyContent="flex-end">
              {!hasInvestorDayFeature && `$${this.props.subtotal}`}
            </Box>
          </Box>
        }
      />
    );
  }
}

ViewCart.defaultProps = {
  to: '/cart'
};

export default ViewCart;
